var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305.9 232.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6b5da8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 167.78,
    width: 138.12,
    height: 133.39,
    rx: 16.09,
    ry: 16.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 35.59,
    width: 138.12,
    height: 133.39,
    rx: 16.09,
    ry: 16.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.76,
    y: 162.35,
    width: 73.03,
    height: 70.52,
    rx: 11.96,
    ry: 11.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.41,144.71s-.66,16.05,14.05,17.64,8.24,17.24,8.24,17.24l-24.45,14.02h-4.49l.25-13.59s-1.6-11.04-14.95-11.04-18.2-9.89-18.2-9.89l39.55-14.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f33eebb3f045dd5f16dbb541bf3125d3.svg";
export { ForwardRef as ReactComponent };